<template>
    <div class="bm bm-f1 bm-ac bm-pc bm-ver table-info">
        <div class="bm table-title-big">
            <div class="bm red-block"></div>
            <div class="bm bm-ac">基础信息</div>
        </div>
        <table cellspacing="0" cellpadding="0" border="0" class="table-boder-color">
            <tr >
                <td class="title-td-right">物料编码</td>
                <td class="title-td-right">{{detailsSimilarobj.itemCode}}</td>
                <td class="title-td-right">物料名称</td>
                <td class="title-td-right">{{detailsSimilarobj.itemName}}</td>
            </tr>
            <tr >
                <td  class="title-td-right">基本单位</td>
                <td  class="title-td-right">{{detailsSimilarobj.unit}}</td>
                <td  class="title-td-right">物料分类</td>
                <td  class="title-td-right">{{detailsSimilarobj.togetherClassNameDetails}}</td>
            </tr>
            <tr >
                <td  class="title-td-right ">采购品类</td>
                <td  class="title-td-right">{{detailsSimilarobj.togetherLevelNameDetails}}</td>
                <td  class="title-td-right">物料组</td>
                <td  class="title-td-right">{{detailsSimilarobj.matkl}}</td>
            </tr>
        </table>
        <div class="bm bm-ac table-title-big">
            <div class="bm red-block"></div>
            <div class="bm bm-ac">{{detailsSimilarobj.itemClass1Name}}信息</div>
        </div>
        <table cellspacing="0" cellpadding="0" border="0" class="table-boder-color">
            <tr v-for="(item, index) in arr2" :key="index+1" >
                <td class="title-td-right" >{{item[0].changname}}</td>
                <td class="title-td-right" :colspan="item[1].changtype?3:''" :style="item[1].changtype?'width: 84%;':''">{{item[0].changval}}</td>
                <td class="title-td-right" v-if="!item[1].changtype">{{item[1].changname}}</td>
                <td class="title-td-right" v-if="!item[1].changtype">{{item[1].changval}}</td>
            </tr>
            <tr v-for="(item, index) in arr" :key="index" >
                <td class="title-td-right">{{item.changname}}</td>
                <td class="title-td-right" colspan="3" style="width: 84%;">{{item.changval}}</td>
            </tr>

        </table>
        <div class="bm bm-ac table-title-big" v-if="systemShow">
            <div class="bm red-block"></div>
            <div class="bm bm-ac">系统信息</div>
        </div>
        <table cellspacing="0" cellpadding="0" border="0" class="table-boder-color" v-if="systemShow">
            <tr >
                <td class="title-td-right">来源</td>
                <td  class="title-td-right" colspan="3">{{detailsSimilarobj.matkl}}</td>
            </tr>
            <tr >
                <td class="title-td-right">提交时间</td>
                <td class="title-td-right" v-if="detailsSimilarobj.createTime">{{detailsSimilarobj.createTime | dateformat('YYYY-MM-DD HH:mm:ss')}}</td>
                <td class="title-td-right" v-if="!detailsSimilarobj.createTime"></td>
                <td class="title-td-right">提交人员</td>
                <td class="title-td-right">{{detailsSimilarobj.creator}}   {{detailsSimilarobj.creatorName}}</td>
            </tr>
            <tr >
                <td  class="title-td-right">启用时间</td>
                <td class="title-td-right" v-if="detailsSimilarobj.activeTime">{{detailsSimilarobj.activeTime | dateformat('YYYY-MM-DD HH:mm:ss')}}</td>
                <td class="title-td-right" v-if="!detailsSimilarobj.activeTime"></td>
                <td class="title-td-right">启用人员</td>
                <td class="title-td-right">{{detailsSimilarobj.activator}}    {{detailsSimilarobj.activatorName}}</td>
            </tr>

        </table>
    </div>
</template>
<script>
const R = require("ramda");
import { permissionsApi } from "@/services";
export default {
	props: {
		id: {
			type: String,
			default: ""
		},
		systemShow: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			detailsSimilarobj: {}, //物料详情
			ruleskzShow: {
				levelCode: "级别编号", //基本信息的校验
				levelName: "级别", //基本信息的校验
				specification: "规格（型号）",
				useChemicalMaterialsCode: "化学原料药用途编号",
				useChemicalMaterialsName: "化学原料药用途",
				origin: "产地",
				specificationMin: "最小包装规格",
				factory: "生产厂家",
				factoryBiomaterial: "生物材料来源",
				marketAreaCode: "市场区域编号",
				marketAreaName: "市场区域",
				texture: "材质",
				chemicalName: "中文化学名",
				components: "模块组件",
				designVolume: "设计容积",
				temperatureRange: "温控范围",
				capacity: "处理量",
				ratedVoltage: "额定电压",
				ratedCapacity: "额定容量",
				brandName: "品牌名称",
				volume: "容积",
				dimensions: "外形尺寸",
			},
			chang: 0,
			duan: 0,
			arr: [],
			arr2: [],

		};
	},
	created() {
		// this.treeData  = mClassData.default;
	},
	watch: {
		id(val) {
			if(!R.isNil(val) && !R.isEmpty(val)){
				//debugger
				this.openDetailsSimilar(val);
			}
		}
	},
	mounted(){
		if(!R.isNil(this.id) && !R.isEmpty(this.id)){
			this.openDetailsSimilar(this.id);
		}
	},
	methods: {
		//物料分类拼接 老的
		togetherClassNameDetails(){
			let materialClass = this.detailsSimilarobj.itemClass1Name;
			if(!R.isNil(this.detailsSimilarobj.itemClass2Name) && !R.isEmpty(this.detailsSimilarobj.itemClass2Name)){
				materialClass +="-"+this.detailsSimilarobj.itemClass2Name;
			}
			if(!R.isNil(this.detailsSimilarobj.itemClass3Name) && !R.isEmpty(this.detailsSimilarobj.itemClass3Name)){
				materialClass +="-"+this.detailsSimilarobj.itemClass3Name;
			}
			if(!R.isNil(this.detailsSimilarobj.itemClass4Name) && !R.isEmpty(this.detailsSimilarobj.itemClass4Name)){
				materialClass +="-"+this.detailsSimilarobj.itemClass4Name;
			}
			return materialClass;
		},
		//采购物品拼接 老的
		togetherLevelNameDetails(){
			let categoryLLevel = this.detailsSimilarobj.categoryLevel0Name;
			if(!R.isNil(this.detailsSimilarobj.categoryLevel1Name) && !R.isEmpty(this.detailsSimilarobj.categoryLevel1Name)){
				categoryLLevel +="-"+this.detailsSimilarobj.categoryLevel1Name;
			}
			if(!R.isNil(this.detailsSimilarobj.categoryLevel2Name) && !R.isEmpty(this.detailsSimilarobj.categoryLevel2Name)){
				categoryLLevel +="-"+this.detailsSimilarobj.categoryLevel2Name;
			}
			if(!R.isNil(this.detailsSimilarobj.categoryLevel3Name) && !R.isEmpty(this.detailsSimilarobj.categoryLevel3Name)){
				categoryLLevel +="-"+this.detailsSimilarobj.categoryLevel3Name;
			}
			return categoryLLevel;
		},
		openDetailsSimilar(id){
			this.chang = 0;
			this.duan = 0;
			this.arr = [];
			this.arr2 = [];
			permissionsApi.detailMaterial({
				"itemId": id
			}).then((resData) => {
				if(resData.msgCode == 100){
					this.detailsSimilarobj = resData.responseData;
					this.detailsSimilarobj.togetherClassNameDetails = this.togetherClassNameDetails();
					this.detailsSimilarobj.togetherLevelNameDetails = this.togetherLevelNameDetails();
					//    this.dialogFormTitle=this.detailsSimilarobj.itemName;
					this.$emit("chooseData", this.detailsSimilarobj.itemName);
					//this.getAttribute(this.detailsSimilarobj.itemClass1Code);
					this.eachDate();
				}
			});
		},
		//遍历数据
		eachDate(){
			for (let i in this.detailsSimilarobj.attributeData) {
				if(!(i == "levelCode" || i == "marketAreaCode" || i == "useChemicalMaterialsCode")){
					let o = {};
					//o[i] = this.detailsSimilarobj.attributeData[i];
					// console.log(i,this.ruleskzShow[i]);
					if(this.detailsSimilarobj.attributeData[i]){
						if( i=="factory" || i== "factoryBiomaterial" || i=="chemicalName"){
							this.chang +=1;
							o.changtype = true;
							o.changname = this.ruleskzShow[i];
							o.changval = this.detailsSimilarobj.attributeData[i];
							if(!(i == "levelCode" || i == "marketAreaCode" || i == "useChemicalMaterialsCode")){
								this.arr.push(o); //属性
							}
						}else{
							o.changtype = false;
							this.duan +=1;
							o.changname = this.ruleskzShow[i];
							o.changval = this.detailsSimilarobj.attributeData[i];
							if(this.arr2 && this.arr2[this.arr2.length-1] && this.arr2[this.arr2.length-1].length==1){
								this.arr2[this.arr2.length-1].push(o);
							}else{
								let newArray = [];
								newArray.push(o);
								this.arr2.push(newArray); //属性
							}
						}
					}
				}
			}
			if(this.arr2 && this.arr2[this.arr2.length-1] && this.arr2[this.arr2.length-1].length == 1){
				let obj = {};
				obj.changtype = true;
				obj.changname = "";
				obj.changval = "";
				this.arr2[this.arr2.length-1].push(obj);
			}
		},
		// 获取物料唯一属性
		getAttribute(itemClass1Code){
			permissionsApi.getAttribute({
				"itemClassCode": itemClass1Code
			}).then((resData) => {
				//debugger
				console.log(resData)
				if(resData.msgCode == 100){
					// this.ruleskzShow = resData.responseData;
				}else{
					// this.$router.push({ path: '/resultsPage' });
				}
			});
		},
	}
}
</script>
<style lang="scss">
.el-dialog__body{
    padding: 0px 20px 30px 20px;
}
.table-info{
    .table-title-big{
        margin-top: 20px;
        margin-bottom: 10px;
        width: 100%;
        line-height: 14px;
        font-weight: 900;
        font-size: 14px;
        color: #323232;
        .red-block{
            margin-right: 13px;
            background-color: red;
            height: 14px;
            width: 4px;
        }
    }
    .table-boder-color tr:last-child td{
            border-bottom: 1px solid #e5e5e5;
        }
        .table-boder-color tr td:last-child{
            border-right: 1px solid #e5e5e5;
        }
        table{
            width: 100%;
            td{
                border: 1px solid #e5e5e5;
                margin-bottom: 20px;
                color: #646464;
                font-size: 14px;
                height: 40px;
                padding-left: 10px;
            }
            td:nth-of-type(3){
                width: 120px;
            }
            td:nth-of-type(1){
                width: 120px;
            }
            .title-td-right{
                border:none;
                border-left: 1px solid #e5e5e5;
                border-top: 1px solid #e5e5e5;
                width: 34%;
            }
        }
}
</style>
